import { Ogp } from "shared/features/utils";
import { NextPageWithLayout } from "shared/types";

import { StandardLayout } from "~/components/layouts";
import { routes } from "~/constants";
import { AuthedRoute } from "~/features/auth";
import { AddressNewPage } from "~/features/users";

const Page: NextPageWithLayout = () => {
  return (
    <AuthedRoute>
      <Ogp title="お届け先の追加" />
      <AddressNewPage returnTo={routes.MYPAGE_ADDRESSES} />
    </AuthedRoute>
  );
};

Page.getLayout = (page) => (
  <StandardLayout>{page}</StandardLayout>
);

export default Page;
